import { useTranslation } from 'react-i18next';
import { useToaster } from './useToaster';

export const useSnackbarHelper = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useToaster();

  return { t, enqueueSnackbar };
};
